'use client'

import { Tooltip } from '@trustoo/components/ui/tooltip/Tooltip'
import {
    TooltipAsPopover,
    type TooltipAsPopoverProps,
} from '@trustoo/components/ui/tooltip/TooltipAsPopover'
import { useIsTouchDevice } from '@trustoo/hooks/useIsTouchDevice'

export type HybridTooltipProps = TooltipAsPopoverProps

export default function HybridTooltip({
    children,
    childrenContent,
    open,
    defaultOpen,
    onOpenChange,
    arrowClassName,
    ...contentProps
}: HybridTooltipProps) {
    if (useIsTouchDevice()) {
        return (
            <TooltipAsPopover
                open={open}
                defaultOpen={defaultOpen}
                onOpenChange={onOpenChange}
                childrenContent={childrenContent}
                arrowClassName={arrowClassName}
                {...contentProps}>
                {children}
            </TooltipAsPopover>
        )
    }

    return (
        <Tooltip
            open={open}
            defaultOpen={defaultOpen}
            onOpenChange={onOpenChange}
            childrenContent={childrenContent}
            arrowClassName={arrowClassName}
            {...contentProps}>
            {children}
        </Tooltip>
    )
}
